export const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    variableWidth: false,
    swipe: true
};